import type { SecondaryDriverOption } from '@/api/projectApi'

export function secondaryDriverLabel(option: SecondaryDriverOption | undefined, locale: string): string {
  if (!option) return ''
  const normalized = normalizeLocale(locale)
  return option.labels[normalized] || option.labels.en || option.labels.zh || option.key
}

function normalizeLocale(locale: string): string {
  const [base] = locale.replace('_', '-').split('-')
  return base?.toLowerCase() || 'en'
}
